var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "currentColor",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3975 17C10.1905 17 9.99254 16.905 9.85079 16.7375L6.20354 12.4216C5.91929 12.0866 5.93504 11.5591 6.23654 11.2441C6.53879 10.9291 7.01354 10.9458 7.29629 11.2808L10.39 14.94L16.696 7.27156C16.9765 6.93072 17.4505 6.90822 17.7565 7.21823C18.0618 7.52823 18.0828 8.05574 17.8038 8.39491L10.951 16.7283C10.8108 16.9 10.6113 16.9983 10.4028 17H10.3975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxTrue);
export default __webpack_public_path__ + "static/media/CheckBoxTrue.9bae7ea4ed6bd991be62c652c4704579.svg";
export { ForwardRef as ReactComponent };